import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class HUD extends Phaser.Group {

    private minesLabel: Phaser.Text;
    private timeLabel: Phaser.Text;
   
    constructor(game: Phaser.Game) {

        super(game, null, "hud");

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 65 * GameVars.scaleY;
        this.scale.y = GameVars.scaleY;

        const timeCapsule = new Phaser.Image(this.game, -165, 0, "texture_atlas_1", "capsule_time");
        timeCapsule.anchor.set(.5);
        this.add(timeCapsule);

        this.timeLabel = new Phaser.Text(this.game, -134, 0, GameVars.secondsToTime(GameVars.time), { font: "38px Eczar", fill: "#ffffff" });
        this.timeLabel.anchor.set(.5);
        this.add(this.timeLabel);

        const minesCapsule = new Phaser.Image(this.game, 165, 0, "texture_atlas_1", "capsule_mines");
        minesCapsule.anchor.set(.5);
        this.add(minesCapsule);

        this.minesLabel = new Phaser.Text(this.game, 134, 0, GameVars.mines.toString(), { font: "46px Eczar", fill: "#ffffff" });
        this.minesLabel.anchor.set(.5);
        this.add(this.minesLabel);
    }

    public updateTimer(): void {

        if (GameVars.time < 3600) {
            this.timeLabel.text = GameVars.secondsToTime(GameVars.time);
        }
    }

    public updateMines(): void {

        this.minesLabel.text = this.formatNumber(GameVars.mines - GameVars.flaggedCells);
    }

    private formatNumber(n: number): string {

        let ret: string;

        if (n >= 0) {
            if (n > 99) {
                ret = n.toString();
            } else if (n > 9) {
                ret = "0" + n.toString();
            } else {
                ret = "00" + n.toString();
            }
        } else {

            if (n < -9) {
                ret = "-" + Math.abs(n);
            } else {
                ret = "-0" + Math.abs(n);
            }
        }

        return ret;
    }
}
